import { render } from "./Departments.vue?vue&type=template&id=73cdaa49&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"

import "./Departments.vue?vue&type=style&index=0&id=73cdaa49&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cdaa49"]])

export default __exports__